import {
  computed,
  ref
} from 'vue'

const windowWidth = ref(window.innerWidth)
let watchingWindowWidth = false

export const useWatchWindowSize = () => {
  const isMobileSize = computed(() => windowWidth.value < 768)

  const watchWindowWidth = () => {
    if (!watchingWindowWidth) {
      watchingWindowWidth = true
      window.addEventListener('resize', () => windowWidth.value = window.innerWidth)
    }
  }

  return {
    // variables
    windowWidth,
    // computed
    isMobileSize,
    // methods
    watchWindowWidth
  }
}
